import type {ReactElement} from 'react';
import {clsx} from 'clsx';
import logo from '@assets/images/logo.svg';

interface Props {
    className?: string;
}

export default function Logo(props: Props): ReactElement<Props> {
    const classNames = clsx([props.className]);

    return <img src={logo} className={classNames} alt="ACTS" />;
}
